import { Button, styled } from "@mui/material";
import { Link } from "react-router-dom";

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1)
}));

const AppLink = ({ text, to }) => {
  return (
    <Link to={to}>
      <StyledButton
        variant="contained"
        className="MuiButton-root MuiButtonBase-root"
        color="primary"
      >
        {text}
      </StyledButton>
    </Link>
  );
};

export default AppLink;
